import type { SVGProps } from 'react';
const SvgSubdirectoryArrowLeft = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#subdirectory_arrow_left_svg__a)">
      <path
        fill="currentColor"
        d="m11 9 1.42 1.42L8.83 14H18V4h2v12H8.83l3.59 3.58L11 21l-6-6 6-6Z"
      />
    </g>
    <defs>
      <clipPath id="subdirectory_arrow_left_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgSubdirectoryArrowLeft;
